/*
 * df-geo.js — Detección de ciudad/región/país vía IP (ipapi.co).
 *
 * Uso:
 *   <span data-df-user-city>tu ciudad</span>
 *   <span data-df-user-region>tu región</span>
 *   <span data-df-user-country>España</span>
 *
 * El JS reemplaza el contenido cuando recibe la respuesta de la API.
 * Si la API falla o el usuario tiene ad-blocker, queda el texto fallback original.
 *
 * Cache: 1 hora en localStorage (df:geo) para no agotar la cuota free (1000/día).
 * API: ipapi.co (HTTPS, sin key, 1000 req/día gratis).
 *
 * Evento global: 'df:geo:ready' (detail = data) — para que otros scripts reaccionen.
 * Objeto global: window.dfGeo = { city, region, country_name, country_code, ... }
 */
(function () {
  'use strict';

  var CACHE_KEY = 'df:geo';
  var CACHE_TTL_MS = 60 * 60 * 1000; // 1 hora
  var API_URL = 'https://ipapi.co/json/';

  function safeJSON(s) {
    try { return JSON.parse(s); } catch (e) { return null; }
  }

  function getCache() {
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      var parsed = safeJSON(raw);
      if (!parsed || !parsed._ts) return null;
      if (Date.now() - parsed._ts > CACHE_TTL_MS) return null;
      return parsed;
    } catch (e) { return null; }
  }

  function setCache(data) {
    try {
      data._ts = Date.now();
      localStorage.setItem(CACHE_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function paint(data) {
    if (!data) return;

    // Ciudad
    if (data.city) {
      document.querySelectorAll('[data-df-user-city]').forEach(function (el) {
        el.textContent = data.city;
        el.setAttribute('data-df-geo-applied', '1');
      });
    }
    // Región (Comunidad Autónoma en ES)
    if (data.region) {
      document.querySelectorAll('[data-df-user-region]').forEach(function (el) {
        el.textContent = data.region;
        el.setAttribute('data-df-geo-applied', '1');
      });
    }
    // País (nombre)
    if (data.country_name) {
      document.querySelectorAll('[data-df-user-country]').forEach(function (el) {
        el.textContent = data.country_name;
        el.setAttribute('data-df-geo-applied', '1');
      });
    }
    // Código país (ISO)
    if (data.country_code) {
      document.querySelectorAll('[data-df-user-country-code]').forEach(function (el) {
        el.textContent = data.country_code;
        el.setAttribute('data-df-geo-applied', '1');
      });
    }

    // Mostrar wrappers ocultos que solo aparecen cuando hay dato
    document.querySelectorAll('[data-df-geo-show-when-ready]').forEach(function (el) {
      el.style.opacity = '1';
      el.style.visibility = 'visible';
    });

    // Hook global
    window.dfGeo = data;
    try {
      document.dispatchEvent(new CustomEvent('df:geo:ready', { detail: data }));
    } catch (e) {}
  }

  // 1. Probar cache (renderiza al instante, sin esperar fetch)
  var cached = getCache();
  if (cached) {
    paint(cached);
  }

  // 2. Si no había cache (o es viejo), fetch fresh
  if (!cached && typeof window.fetch === 'function') {
    fetch(API_URL, { method: 'GET', cache: 'no-cache' })
      .then(function (r) {
        if (!r.ok) throw new Error('ipapi http ' + r.status);
        return r.json();
      })
      .then(function (data) {
        if (!data || data.error) return;
        setCache(data);
        paint(data);
      })
      .catch(function () { /* silently fail — fallback text se queda */ });
  }
})();
